import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FaStar } from "react-icons/fa";
import "./ClassesSection.css";

// Import your images
import imgIELTS from "../Assets/aboutcourse1.png";
import imgBasic from "../Assets/aboutcourse2.png";
import imgAdvanced from "../Assets/aboutcourse3.png";

const CourseClassesSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("junior");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

const courses = {
  junior: [
    {
      title: "Best Online IELTS Courses",
      desc: "IELTS examination opens the door for many different opportunities...",
      img: imgIELTS,
      rating: 4.5,
      label: "Junior Level",
      labelColor: "#ec407a", // pink
      // price:"340"
    },
    {
      title: "Basic Level: Spoken English",
      desc: "For individuals who can read/write English but lack confidence...",
      img: imgBasic,
      rating: 5,
      label: "Junior Level",
      labelColor: "#ec407a",
      // price:"2400"
    },
    {
      title: "Best Online IELTS Courses",
      desc: "IELTS examination opens the door for many different opportunities...",
      img: imgIELTS,
      rating: 4.5,
      label: "Junior Level",
      labelColor: "#ec407a",
      // price:"340"
    },
    {
      title: "Basic Level: Spoken English",
      desc: "For individuals who can read/write English but lack confidence...",
      img: imgBasic,
      rating: 5,
      label: "Junior Level",
      labelColor: "#ec407a",
      // price:"340"
    }
  ],
  midsenior: [
    {
      title: "Advanced Level: Spoken English",
      desc: "Designed for professionals who need high-level communication skills...",
      img: imgAdvanced,
      rating: 4,
      label: "Mid-Senior Level",
      labelColor: "#000",
      // price:"340" // black
    }

  ],
  supersenior: [
    {
      title: "Advanced Level: Spoken English",
      desc: "Designed for professionals who need high-level communication skills...",
      img: imgAdvanced,
      rating: 4,
      label: "Super Senior Level",
      labelColor: "#000",
      // price:"340"
    }
  ]
};


  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    return (
      <>
        {[...Array(fullStars)].map((_, i) => (
          <FaStar key={i} color="#FFD700" />
        ))}
        {hasHalfStar && <FaStar color="#FFD700" style={{ opacity: 0.5 }} />}
      </>
    );
  };

const renderCourseCard = (course, index) => (
  <div className="course-card" key={index}>
    <img src={course.img} alt={course.title} className="course-image" />
    <div className="course-content">
      <p>{course.desc}</p>
    </div>
  </div>
);


  return (
    <section className="classes-section">
      <h2 className="section-title">Why Choose the Beginner Course?</h2>
      {isMobile ? (
        <div className="accordion">
          {Object.keys(courses).map((level) => (
            <details key={level}>
              <summary>{level.replace(/([A-Z])/g, " $1").toUpperCase()}</summary>
              <div className="accordion-content">
                {courses[level].map(renderCourseCard)}
              </div>
            </details>
          ))}
        </div>
      ) : (
        <>

          <Slider {...sliderSettings}>
            {courses[activeTab].map(renderCourseCard)}
          </Slider>

        </>
      )}
    </section>
  );
};

export default CourseClassesSection;
